import { TanstackError } from "../client";

interface OnboardingResult {
  executionArn: string;
  startDate: string;
}

interface OnboardingApiResponse {
  success: boolean;
  data: OnboardingResult;
  error?: string;
}

/**
 * Trigger contractor onboarding (pricing sync + recent products)
 */
export async function triggerOnboarding(
  orgId: string
): Promise<OnboardingResult> {
  const response = await fetch(
    `/api/internal/contractors/${orgId}/onboarding`,
    {
      method: "POST",
      credentials: "include",
    }
  );

  const result: OnboardingApiResponse = await response.json();

  if (!response.ok || !result.success) {
    throw new TanstackError(
      response.status,
      result.error || "Failed to trigger onboarding"
    );
  }

  return result.data;
}
